import React from 'react'
import ClipLoader from 'react-spinners/ClipLoader'
import styles from './index.module.scss'
import { t } from '../../i18n'

interface SpinnerProps {
  loading?: boolean
  text: string
  className?: string
  size?: number
}

const SpinnerWithText = ({ loading, text, className, size }: SpinnerProps) => {
  const classNames = [styles.loader_container]
  if (className) {
    classNames.push(className)
  }

  return (
    <div className={classNames.join(' ')}>
      <ClipLoader
        size={size || 100}
        color={t('spinner_color')}
        loading={loading}
      />
      <p>{text}</p>
    </div>
  )
}

export default React.memo(SpinnerWithText)
